import { createContext } from 'react';

interface NonceContext {
  nonce: string;
}
export const NonceContext = createContext<NonceContext>(null as unknown as NonceContext);
